import { createActionGroup, props } from '@ngrx/store';
import { GetHomeConfigPayload, HomeCoachsData, HomeData, HomeSyncPayload, SetHomeConfigPayload, SyncError } from '../homes/homes.interface';
import { APIResponseError } from '../interfaces/erros';
import { ChangePolarityPayload, HomeErrors, ModuleData, ModuleNameUpdate, ModuleRoomUpdate, RemoveDataGatewayPayload, RemoveModulePayload, TransferMeasurementsPayload } from './modules.interface';

export const ModulesActions = createActionGroup({
  source: 'Modules',
  events: {
    // Modules
    'Get Modules': props<{ payload: ModuleData[] }>(),
    'Get Modules Success': props<{ payload: HomeData[]; modules?: ModuleData[] }>(),
    'Get Modules Failure': props<{ payload: SyncError[] }>(),

    'Select Module': props<{ payload: string }>(),

    'Update Modules Status': props<{ payload: HomeSyncPayload }>(),
    'Update Modules Get Config': props<{ payload: GetHomeConfigPayload }>(),
    'Update Modules Set Config': props<{ payload: SetHomeConfigPayload }>(),
    'Set Modules Errors': props<{ payload: HomeErrors }>(),
    'Set Modules Status Errors': props<{ payload: HomeErrors }>(),

    // Module name
    'Update Module Name': props<{ payload: ModuleNameUpdate; header?: Record<string, string> }>(),
    'Update Module Name Success': props<{ payload: ModuleNameUpdate }>(),
    'Update Module Name Failure': props<{ payload: any }>(),

    // Module room
    'Update Module Room': props<{ payload: ModuleRoomUpdate; header?: Record<string, string> }>(),
    'Update Module Room Success': props<{ payload: ModuleRoomUpdate }>(),
    'Update Module Room Failure': props<{ payload: APIResponseError }>(),

    // Remove module from home
    'Remove Module From Home': props<{ payload: RemoveModulePayload }>(),
    'Remove Module From Home Success': props<{ payload: RemoveModulePayload }>(),
    'Remove Module From Home Failure': props<{ payload: any }>(),

    // Polarity
    'Change Polarity': props<{ payload: ChangePolarityPayload }>(),
    'Change Polarity Success': props<{ payload: ChangePolarityPayload }>(),
    'Change Polarity Failure': props<{ payload: ChangePolarityPayload }>(),

    // Data gateway
    'Remove Data Gateway': props<{ payload: RemoveDataGatewayPayload }>(),
    'Remove Data Gateway Success': props<{ payload: RemoveDataGatewayPayload }>(),
    'Remove Data Gateway Failure': props<{ payload: string }>(),

    'Update Read Only Devices Status': props<{ payload: ModuleData[] }>(),
    'Remove Home Modules': props<{ payload: { id: string } }>(),

    // Transfer measurements
    'Transfer Module Measurements': props<{ payload: TransferMeasurementsPayload }>(),
    'Transfer Module Measurements Success': props<{ payload: TransferMeasurementsPayload }>(),
    'Transfer Module Measurements Failure': props<{ payload: TransferMeasurementsPayload }>(),

    // Home coachs
    'Get Modules Home Coachs Success': props<{ payload: HomeCoachsData }>(),
    'Get Modules Home Coachs Failure': props<{ payload: any }>(),
  },
});

export type ModulesActionUnion = ReturnType<typeof ModulesActions[keyof typeof ModulesActions]>;

// Types unitaires
export type GetModules = ReturnType<typeof ModulesActions.getModules>;
export type GetModulesSuccess = ReturnType<typeof ModulesActions.getModulesSuccess>;
export type GetModulesFailure = ReturnType<typeof ModulesActions.getModulesFailure>;

export type SelectModuleAction = ReturnType<typeof ModulesActions.selectModule>;

export type UpdateModulesStatus = ReturnType<typeof ModulesActions.updateModulesStatus>;
export type UpdateModulesGetConfig = ReturnType<typeof ModulesActions.updateModulesGetConfig>;
export type UpdateModulesSetConfig = ReturnType<typeof ModulesActions.updateModulesSetConfig>;
export type SetModulesErrors = ReturnType<typeof ModulesActions.setModulesErrors>;
export type SetModulesStatusErrors = ReturnType<typeof ModulesActions.setModulesStatusErrors>;

export type UpdateModuleName = ReturnType<typeof ModulesActions.updateModuleName>;
export type UpdateModuleNameSuccess = ReturnType<typeof ModulesActions.updateModuleNameSuccess>;
export type UpdateModuleNameFailure = ReturnType<typeof ModulesActions.updateModuleNameFailure>;

export type UpdateModuleRoom = ReturnType<typeof ModulesActions.updateModuleRoom>;
export type UpdateModuleRoomSuccess = ReturnType<typeof ModulesActions.updateModuleRoomSuccess>;
export type UpdateModuleRoomFailure = ReturnType<typeof ModulesActions.updateModuleRoomFailure>;

export type RemoveModuleFromHome = ReturnType<typeof ModulesActions.removeModuleFromHome>;
export type RemoveModuleFromHomeSuccess = ReturnType<typeof ModulesActions.removeModuleFromHomeSuccess>;
export type RemoveModuleFromHomeFailure = ReturnType<typeof ModulesActions.removeModuleFromHomeFailure>;

export type ChangePolarity = ReturnType<typeof ModulesActions.changePolarity>;
export type ChangePolaritySuccess = ReturnType<typeof ModulesActions.changePolaritySuccess>;
export type ChangePolarityFailure = ReturnType<typeof ModulesActions.changePolarityFailure>;

export type RemoveDataGateway = ReturnType<typeof ModulesActions.removeDataGateway>;
export type RemoveDataGatewaySuccess = ReturnType<typeof ModulesActions.removeDataGatewaySuccess>;
export type RemoveDataGatewayFailure = ReturnType<typeof ModulesActions.removeDataGatewayFailure>;

export type UpdateReadOnlyDevicesStatus = ReturnType<typeof ModulesActions.updateReadOnlyDevicesStatus>;
export type RemoveHomeModules = ReturnType<typeof ModulesActions.removeHomeModules>;

export type TransferModuleMeasurements = ReturnType<typeof ModulesActions.transferModuleMeasurements>;
export type TransferModuleMeasurementsSuccess = ReturnType<typeof ModulesActions.transferModuleMeasurementsSuccess>;
export type TransferModuleMeasurementsFailure = ReturnType<typeof ModulesActions.transferModuleMeasurementsFailure>;

export type GetModulesHomeCoachsSuccess = ReturnType<typeof ModulesActions.getModulesHomeCoachsSuccess>;
export type GetModulesHomeCoachsFailure = ReturnType<typeof ModulesActions.getModulesHomeCoachsFailure>;
